<template>
  <div id="app">
    <component :is="layout" :style="{'font-family': $store.state.general.language == 'english' ? english : japanese}">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </component>
  </div>
</template>

<script>
    const default_layout = "default";

    export default {
        name: 'app',

        data: function() {
        return {
            user: {},
            japanese:'"Hiragino Kaku Gothic Pro", "ＭＳ Ｐゴシック"',
            english:'"Proxima Nova", Helvetica, Arial, sans-serif'
        }
        },

        created() {
          this.$store.dispatch('user/getMe', {})
          this.$store.dispatch('user/getFavoriteIds', {})
          this.$store.dispatch('general/getSliders')
           if (localStorage.getItem('query')) {
            try {
              this.$store.commit('search/set_selected_results',JSON.parse(localStorage.getItem('query')))
              this.$store.commit('search/set_query',JSON.parse(localStorage.getItem('query')));
              // localStorage.removeItem('query');
            } catch(e) {
              // localStorage.removeItem('query');
            }
          }
        },

        computed: {
            layout() {
                return (this.$route.meta.layout || default_layout) + '-layout';
            }
        }
    }
</script>
